module.exports = __webpack_public_path__ + "static/img/9.d18c268.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/zh/9.png
// module id = /WFT
// module chunks = 0